"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataObserver = void 0;
const tslib_1 = require("tslib");
const lodash_isboolean_1 = tslib_1.__importDefault(require("lodash.isboolean"));
const lodash_isnil_1 = tslib_1.__importDefault(require("lodash.isnil"));
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../../utils");
/**
 * # ⚡️ DataObserver
 *
 * Observes data to check if it is data is loading, loaded or empty. The resulting flags
 * are passed on to the children function. These flags may be used to show different UIs,
 * i.e. loading state, empty state, etc.
 *
 * ## Usage
 * ```jsx
 * <DataObserver>
 *  <Text>{data}</Text>
 * </DataObserver>
 * ```
 */
class DataObserver extends react_1.default.PureComponent {
    render() {
        const { children } = this.props;
        return (0, utils_1.renderChildrenWithProps)(children, {
            data: this.props.data,
            empty: this.props.isEmpty ? this.props.isEmpty(this.props) : false,
            loading: this.props.isLoading ? this.props.isLoading(this.props) : false,
        });
    }
}
exports.DataObserver = DataObserver;
DataObserver.defaultProps = {
    loading: false,
    isEmpty: (props) => {
        // If its null or undefined
        if ((0, lodash_isnil_1.default)(props.data)) {
            return true;
        }
        // If its an empty array
        if (Array.isArray(props.data) && props.data.length === 0) {
            return true;
        }
        return false;
    },
    isLoading: (props) => !(0, lodash_isnil_1.default)(props.loading) && (0, lodash_isboolean_1.default)(props.loading) ? props.loading : false,
};
